module.exports = __webpack_public_path__ + "static/Ryan Parag-Product Designer_Portfolio-a1179c7672ccd4f9fd9b827f30167e43.pdf";